// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
/**
 * sequent-core's monitoring policy, run in the browser on every keystroke.
 *
 * Feature-detected: a sequent-core build without the monitoring export (or
 * whose WebAssembly is not loaded yet) yields no local checks, and the editor
 * relies on the server's, which run the same policy.
 */
import { normalizeProblems } from "@/components/monitoring/lib/problems";
export var WASM_VALIDATE_EXPORT = "validateMonitoringConfig";
var findExport = function (module) {
    var candidate = Reflect.get(module, WASM_VALIDATE_EXPORT);
    return typeof candidate === "function" ? candidate : undefined;
};
/**
 * A validator for documents of `kind`, checked alone and, when `configSet`
 * is given, against the event's other documents, the draft replacing the
 * document stored under `key` (so a changed id is reported, not duplicated).
 * `null` from the validator means the module has no such export.
 */
export var createLocalValidator = function (module, kind, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.key, key = _c === void 0 ? "" : _c, configSet = _b.configSet;
    var configSetJson = configSet === undefined ? "" : JSON.stringify(configSet);
    return function (text) {
        var validate = findExport(module);
        if (!validate)
            return null;
        var report = validate(kind, key, text, configSetJson);
        return normalizeProblems(Array.isArray(report) ? report : report === null || report === void 0 ? void 0 : report.problems);
    };
};
